import { Table } from '@dixa/lib-shared-habla';

import { type ConversationsTableSortableField } from '../../../conversationsTable.types';
import { TextPlaceholder } from '../../placeholders/textPlaceholder/textPlaceholder';

export type ConversationsTableHeadRowProps = {
  /** Whether the table has been initialized. */
  isInitialized?: boolean;
};

export const ConversationsTableHeadRow = ({
  isInitialized,
}: ConversationsTableHeadRowProps): JSX.Element => {
  return (
    <Table.Tr>
      <Table.Th width="128px" columnId={isInitialized ? 'conversation' : null}>
        {!isInitialized ? <TextPlaceholder width="74px" /> : 'Conversation'}
      </Table.Th>

      <Table.Th width="32%" columnId={null}>
        {!isInitialized ? <TextPlaceholder width="60px" /> : 'Customer'}
      </Table.Th>

      <Table.Th width="13%" columnId={null}>
        {!isInitialized ? <TextPlaceholder width="40px" /> : 'Queue'}
      </Table.Th>

      <Table.Th width="160px" columnId={null}>
        {!isInitialized ? <TextPlaceholder width="40px" /> : 'Status'}
      </Table.Th>

      <Table.Th width="10%" columnId={null}>
        {!isInitialized ? <TextPlaceholder width="50px" /> : 'Channel'}
      </Table.Th>

      <Table.Th width="15%" columnId={null}>
        {!isInitialized ? <TextPlaceholder width="88px" /> : 'Assigned agent'}
      </Table.Th>

      <Table.Th
        width="10%"
        tooltip={
          isInitialized
            ? 'Based on customer, agent, and automated messages.'
            : undefined
        }
        columnId={
          isInitialized
            ? ('last_message_created_at' satisfies ConversationsTableSortableField)
            : null
        }
      >
        {!isInitialized ? <TextPlaceholder width="50px" /> : 'Last message'}
      </Table.Th>

      <Table.Th
        width="10%"
        columnId={
          isInitialized
            ? ('created_at' satisfies ConversationsTableSortableField)
            : null
        }
      >
        {!isInitialized ? <TextPlaceholder width="50px" /> : 'Created'}
      </Table.Th>

      <Table.Th width="110px" columnId={null} />
    </Table.Tr>
  );
};
